import { ExclamationCircleFilled } from "@ant-design/icons";
import { LinkOutlined } from "@ant-design/icons";
import {
  createProfileHonor,
  deleteProfileHonor,
  getProfileHonors,
} from "Admin/Service/Profile";
import { handleAPIResponse } from "Admin/Utils/HandleAPIResponse";
import { LoadingListEntityProfile } from "Explore/Components";
import {
  Button,
  Empty,
  Form,
  Input,
  message,
  Modal,
  Tooltip,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import styles from "./Honors.module.scss";
import { formItemLayout } from "Admin/Config/FormLayout";
import { IconPack } from "Admin/Config/Icon";
const { Paragraph, Text, Link } = Typography;
const { confirm } = Modal;
const QuotationAndCitation = ({ quotation, citationURL }) => {
  const displayText =
    quotation?.length > 0
      ? quotation
      : "The information is extracted but not yet verified";
  return (
    <div>
      <Paragraph>
        <Link href={citationURL} target="_blank">
          <LinkOutlined />
        </Link>
        &nbsp;
        <Text type="secondary" style={{ fontStyle: "italic" }}>
          {displayText}
        </Text>
        <Tooltip title={citationURL}></Tooltip>
      </Paragraph>
    </div>
  );
};

const Honors = () => {
  const [form] = Form.useForm();
  const [data, setData] = useState({
    data: [],
    isLoading: true,
    source_url: null,
  });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalRows: 0,
  });
  const [openAddHonorModal, setOpenAddHonorModal] = useState(false);
  const [openDeleteHonorModal, setOpenDeleteHonorModal] = useState(false);
  useEffect(() => {
    setData({ data: [], isLoading: true });
    getProfileHonors(pagination.page - 1, pagination.rowsPerPage, (res) => {
      handleAPIResponse(res, () => {
        setData({
          data: res.data.awards,
          isLoading: false,
          source_url: res.data.honor_award_source_urls,
        });
        if (res.data.total) {
          setPagination({
            ...pagination,
            totalRows: res.data.total,
          });
        }
      });
    });
  }, []);
  const Honor = ({ honor }) => {
    return (
      <div className={styles["honor-wrapper"]}>
        <div className={styles["honor"]}>
          <div className={styles["title"]}>
            <span>
              <b>{honor.award_name}</b>
            </span>
            {honor.award_year && (
              <span className={styles["year"]}>
                <i>. {honor.award_year}</i>
              </span>
            )}
          </div>
          <div className={styles["organization"]}>
            <span>
              <span className={styles["section-title"]}>Organization:</span>
              <span> {honor.awarding_organization}</span>
            </span>
          </div>
          <QuotationAndCitation
            quotation={
              honor.raw?.length > 0
                ? `"...` + honor.raw.join(". ") + `..."`
                : ""
            }
            citationURL={data.source_url}
          />
        </div>
        <div
          className={styles["delete-honor"]}
          onClick={() => handleDeleteHonor(honor)}
        >
          {IconPack.delete_icon}
        </div>
      </div>
    );
  };
  const handleAddHonor = () => {
    createProfileHonor(form.getFieldsValue(), (res) => {
      handleAPIResponse(res, () => {
        setData({
          ...data,
          data: [form.getFieldsValue(), ...data.data],
        });
      });
    });
    setOpenAddHonorModal(false);
  };
  const handleDeleteHonor = (honor) => {
    const payload = {
      award_name: honor.award_name,
      award_year: honor.award_year,
      awarding_organization: honor.awarding_organization,
    };
    confirm({
      title: "Are you sure delete this honor?",
      icon: <ExclamationCircleFilled />,
      content: "This action is irreversible.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      open: openDeleteHonorModal,
      onOk() {
        deleteProfileHonor(payload, (res) => {
          handleAPIResponse(res, () => {
            const updateList = data.data.filter((item) => item !== honor);
            setData({ data: updateList, isLoading: false });
            message.success("Delete honor successfully");
            setOpenDeleteHonorModal(false);
          });
        });
      },
      onCancel() {
        setOpenDeleteHonorModal(false);
      },
    });
  };
  return (
    <div className={styles["honors"]}>
      <Modal
        title="Add honor"
        open={openAddHonorModal}
        onOk={handleAddHonor}
        width={1000}
        onCancel={() => setOpenAddHonorModal(false)}
      >
        <Form
          {...formItemLayout}
          form={form}
          onFinish={handleAddHonor}
          layout="vertical"
        >
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"Honor name:"}
            labelAlign="left"
            name="award_name"
          >
            <Input placeholder="Please input the award name" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"Year:"}
            labelAlign="left"
            name="award_year"
          >
            <Input placeholder="Please input the award year" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"Awarding organization:"}
            labelAlign="left"
            name="awarding_organization"
          >
            <Input placeholder="Please input the awarding organization" />
          </Form.Item>
        </Form>
      </Modal>
      <div className={styles["add-button"]}>
        <Button type="primary" onClick={() => setOpenAddHonorModal(true)}>
          Add honor
        </Button>
      </div>
      <LoadingListEntityProfile
        isLoading={data.isLoading}
        component={
          data?.data?.length > 0 ? (
            data?.data?.map((item, index) => {
              return <Honor honor={item} key={index} />;
            })
          ) : (
            <Empty description="No Honor Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={false}
      />
    </div>
  );
};

export default Honors;
